import React, { useMemo } from 'react';
import { T, fontBody } from '../tokens';
import { FilterBar } from '../TabBar';
import TemplateCard from './TemplateCard';

function matchesSearch(template, query) {
  if (!query) return true;
  const q = query.toLowerCase();
  const haystack = [
    template.name,
    template.trigger,
    template.body,
    template.dmBody,
    ...(template.keywords || []),
  ].join(' ').toLowerCase();
  return haystack.includes(q);
}

export default function TemplateList({
  templates,
  filter,
  search,
  onFilterChange,
  onSearchChange,
  onEdit,
  onToggleStatus,
  onDelete,
  toggling,
}) {
  const cards = useMemo(() => templates.filter((t) => {
    const statusOk = filter === 'all' ? true : t.status.toLowerCase() === filter;
    return statusOk && matchesSearch(t, search);
  }), [templates, filter, search]);

  return (
    <>
      <FilterBar
        filter={filter}
        onFilterChange={onFilterChange}
        search={search}
        onSearchChange={onSearchChange}
      />
      {cards.length === 0 ? (
        <div style={{
          padding: '48px 0',
          textAlign: 'center',
          color: T.slate,
          fontFamily: fontBody,
          fontSize: 14,
        }}
        >
          {search ? 'No automations match your search.' : 'No automations match this filter.'}
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16, overflow: 'hidden' }}>
          {cards.map((t) => (
            <TemplateCard
              key={t.id || t.templateType}
              template={t}
              onEdit={onEdit}
              onToggleStatus={onToggleStatus}
              onDelete={onDelete}
              toggling={toggling}
            />
          ))}
        </div>
      )}
    </>
  );
}

